import { ClassDictionary } from 'clsx';

type Size = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

export type Range = {
  from?: Size;
  upto?: Size;
};

const sizes: Size[] = ['xs', 'sm', 'md', 'lg', 'xl'];

export const buildHideClassDict = ({
  from = 'xs',
  upto = 'xl',
}: Range): ClassDictionary => {
  const inRange = (size: Size): boolean => {
    const idx = sizes.indexOf(size);
    return idx >= sizes.indexOf(from) && idx <= sizes.indexOf(upto);
  };
  return {
    'lui-hide-xs': inRange('xs'),
    'lui-hide-sm': inRange('sm'),
    'lui-hide-md': inRange('md'),
    'lui-hide-lg': inRange('lg'),
    'lui-hide-xl': inRange('xl'),
  };
};
